import { AiOutlineCalendar } from "react-icons/ai";
import { BiCalendarX } from "react-icons/bi";
import { CiGrid41, CiViewTimeline } from "react-icons/ci";
import { FaCar } from "react-icons/fa";
import {
  HiOutlineCreditCard,
  HiOutlineGift,
  HiOutlineQuestionMarkCircle,
  HiOutlineUserCircle,
  HiOutlineUsers,
} from "react-icons/hi";
import {
  MdDirectionsBike,
  MdOutlineAccountCircle,
  MdOutlineAdminPanelSettings,
  MdOutlineAttachMoney,
  MdOutlineCategory,
  MdOutlineDirectionsBike,
  MdOutlinePolicy,
  MdOutlineSettings,
  MdPayment,
  MdPinDrop,
  MdReportProblem,
} from "react-icons/md";
import { RiAdminLine, RiContactsBookLine } from "react-icons/ri";
import { SlBadge } from "react-icons/sl";

export const ROOTS_DASHBOARD = "/admin";

export const PATH_AUTH = {
  login: "/login",
  privacy: "/privacy-policy",
};

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const PATH_DASHBOARD = path(ROOTS_DASHBOARD, "/dashboard");

const menu = [
  {
    title: "General",
    icon: <CiGrid41 size={35} color="#ddd" />,
    childrens: [
      {
        title: "Dashboard",
        path: path(ROOTS_DASHBOARD, "/dashboard"),
        icon: <CiViewTimeline size={20} />,
      },
      {
        title: "Notification",
        path: path(ROOTS_DASHBOARD, "/notifications"),
        icon: <AiOutlineCalendar size={20} />,
      },
      {
        title: "Trips",
        path: path(ROOTS_DASHBOARD, "/trips"),
        icon: <MdOutlineDirectionsBike size={20} />,
      },
    ],
  },
  // {
  //   title: "Maps",
  //   icon: <HiOutlineMap size={35} color="#ddd" />,
  //   childrens: [
  //     {
  //       title: "Live Tracking",
  //       path: path(ROOTS_DASHBOARD, "/maps/live-tracking"),
  //       icon: <HiOutlineMapPin size={20} />,
  //     },
  //     {
  //       title: "Heat Map",
  //       path: "/heat-map",
  //       icon: <GiWorld size={20} />,
  //     },
  //   ],
  // },
  {
    title: "Users",
    icon: <HiOutlineUsers size={35} color="#ddd" />,
    childrens: [
      {
        title: "Admin",
        path: path(ROOTS_DASHBOARD, "/users/admins"),
        icon: <RiAdminLine size={20} />,
      },
      {
        title: "Customers",
        path: path(ROOTS_DASHBOARD, "/users/customers"),
        icon: <HiOutlineUsers size={20} />,
      },
      {
        title: "Riders",
        path: path(ROOTS_DASHBOARD, "/users/riders"),
        icon: <MdDirectionsBike size={20} />,
      },
      // {
      //   title: "Today Riders",
      //   path: path(ROOTS_DASHBOARD, "/users/today-riders"),
      //   icon: <MdPedalBike size={20} />,
      // },
      // {
      //   title: "Deleted Users",
      //   path: path(ROOTS_DASHBOARD, "/users/deleted-users"),
      //   icon: <AiOutlineUserDelete size={20} />,
      // },
      // {
      //   title: "Users OTP",
      //   path: path(ROOTS_DASHBOARD, "/users/users-otp"),
      //   icon: <MdPassword size={20} />,
      // },
      {
        title: "Roles",
        path: path(ROOTS_DASHBOARD, "/users/roles"),
        icon: <MdOutlineAdminPanelSettings size={20} />,
      },
      // {
      //   title: "Persmissions",
      //   path: path(ROOTS_DASHBOARD, "/users/permissions"),
      //   icon: <MdOutlineLockOpen size={20} />,
      // },
    ],
  },

  {
    title: "Accounts",
    icon: <MdOutlineAccountCircle size={35} color="#ddd" />,
    childrens: [
      {
        title: "Transactions",
        path: path(ROOTS_DASHBOARD, "/accounts/transactions"),
        icon: <HiOutlineCreditCard size={20} />,
      },

      {
        title: "Wallets",
        path: path(ROOTS_DASHBOARD, "/accounts/wallets"),
        icon: <HiOutlineCreditCard size={20} />,
      },
    ],
  },

  // {
  //   title: "Requests",
  //   icon: <MdHistory size={35} color="#ddd" />,
  //   childrens: [
  //     {
  //       title: "Trip History",
  //       path: path(ROOTS_DASHBOARD, "/trip-history"),
  //       icon: <MdHistory size={20} />,
  //     },
  //   ],
  // },

  {
    title: "Ratings",
    icon: <HiOutlineUserCircle size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/review-ratings"),
  },

  {
    title: "Support",
    icon: <HiOutlineUserCircle size={35} color="#ddd" />,
    childrens: [
      {
        title: "FAQs",
        path: path(ROOTS_DASHBOARD, "/supports/faqs"),
        icon: <HiOutlineQuestionMarkCircle size={20} />,
      },

      {
        title: "FAQs Categories",
        path: path(ROOTS_DASHBOARD, "/supports/faqs-categories"),
        icon: <HiOutlineQuestionMarkCircle size={20} />,
      },
      {
        title: "Cancel Reasons",
        path: path(ROOTS_DASHBOARD, "/supports/cancel-reasons"),
        icon: <BiCalendarX size={20} />,
      },

      // {
      //   title: "Emergency Contacts",
      //   path: path(ROOTS_DASHBOARD, "/supports/emergency-contacts"),
      //   icon: <RiContactsBookLine size={20} />,
      // },

      // {
      //   title: "Reports",
      //   path: path(ROOTS_DASHBOARD, "/supports/reports"),
      //   icon: <MdReportProblem size={20} />,
      //   childrens: [
      //     {
      //       title: "Reports list",
      //       path: path(ROOTS_DASHBOARD, "/supports/reports/list"),
      //       icon: <MdReportProblem size={20} />,
      //     },
      //     {
      //       title: "Reports Types",
      //       path: path(ROOTS_DASHBOARD, "/supports/reports/types"),
      //       icon: <MdReportProblem size={20} />,
      //     },
      //   ],
      // },
    ],
  },
  {
    title: "Settings",
    icon: <MdPayment size={35} color="#ddd" />,
    childrens: [
      {
        title: "Vehicles",
        path: path(ROOTS_DASHBOARD, "/settings/vehicles"),
        icon: <FaCar size={20} />,

        childrens: [
          {
            title: "Types",
            path: path(ROOTS_DASHBOARD, "/settings/vehicles/types"),
            icon: <FaCar size={20} />,
          },
          {
            title: "Brands",
            path: path(ROOTS_DASHBOARD, "/settings/vehicles/brands"),
            icon: <FaCar size={20} />,
          },

          {
            title: "CC",
            path: path(ROOTS_DASHBOARD, "/settings/vehicles/cc"),
            icon: <FaCar size={20} />,
          },

          {
            title: "Colors",
            path: path(ROOTS_DASHBOARD, "/settings/vehicles/colors"),
            icon: <FaCar size={20} />,
          },

          // {
          //   title: "Symbols",
          //   path: path(ROOTS_DASHBOARD, "/settings/vehicles/symbols"),
          //   icon: <FaCar size={20} />,
          // },

          {
            title: "Models",
            path: path(ROOTS_DASHBOARD, "/settings/vehicles/models"),
            icon: <FaCar size={20} />,
          },
        ],
      },

      {
        title: "Promo Code",
        path: path(ROOTS_DASHBOARD, "/settings/promo-code"),
        icon: <HiOutlineGift size={20} />,
      },

      {
        title: "Badges",
        path: path(ROOTS_DASHBOARD, "/settings/badges"),
        icon: <SlBadge size={20} />,
      },

      // {
      //   title: "Commissions",
      //   path: path(ROOTS_DASHBOARD, "/settings/commissions"),
      //   icon: <RiMoneyDollarCircleLine size={20} />,
      // },

      // {
      //   title: "Rewards",
      //   path: path(ROOTS_DASHBOARD, "/settings/rewards"),
      //   icon: <HiOutlineGift size={20} />,
      // },

      // {
      //   title: "Documents",
      //   path: path(ROOTS_DASHBOARD, "/settings/document-types"),
      //   icon: <MdOutlineDocumentScanner size={20} />,
      // },

      {
        title: "Categories",
        path: path(ROOTS_DASHBOARD, "/settings/categories"),
        icon: <MdOutlineCategory size={20} />,
      },

      {
        title: "Suspend Policies",
        path: path(ROOTS_DASHBOARD, "/settings/suspend-policies"),
        icon: <MdOutlinePolicy size={20} />,
      },

      {
        title: "Service Areas",
        path: path(ROOTS_DASHBOARD, "/settings/service-areas"),
        icon: <MdPinDrop size={20} />,
      },

      {
        title: "Fares",
        path: path(ROOTS_DASHBOARD, "/settings/fares"),
        icon: <MdOutlineAttachMoney size={20} />,
        childrens: [
          {
            title: "Fares list",
            path: path(ROOTS_DASHBOARD, "/settings/fares/list"),
            icon: <MdOutlineAttachMoney size={20} />,
          },
          {
            title: "Fares Types",
            path: path(ROOTS_DASHBOARD, "/settings/fares/types"),
            icon: <MdOutlineAttachMoney size={20} />,
          },
        ],
      },

      {
        title: "Settings",
        path: path(ROOTS_DASHBOARD, "/settings"),
        icon: <MdOutlineSettings size={20} />,
      },
    ],
  },
];

export default menu;
